import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import VerifyEmail from './pages/VerifyEmail';
import PendingApproval from './pages/PendingApproval';
import Dashboard from './pages/client/Dashboard';
import NewProject from './pages/client/NewProject';
import ProjectDetail from './pages/client/ProjectDetail';
import WorkQueue from './pages/worker/WorkQueue';
import LabelCanvas from './pages/worker/LabelCanvas';
import ReviewQueue from './pages/reviewer/ReviewQueue';
import AdminOverview from './pages/admin/AdminOverview';
import DemoQueue from './pages/admin/DemoQueue';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/pending-approval" element={<PendingApproval />} />

          {/* Authenticated routes */}
          <Route
            path="/dashboard"
            element={<PrivateRoute><Dashboard /></PrivateRoute>}
          />
          <Route
            path="/projects/new"
            element={<PrivateRoute><NewProject /></PrivateRoute>}
          />
          <Route
            path="/projects/:id"
            element={<PrivateRoute><ProjectDetail /></PrivateRoute>}
          />
          <Route
            path="/work"
            element={<PrivateRoute><WorkQueue /></PrivateRoute>}
          />
          <Route
            path="/work/:taskId"
            element={<PrivateRoute><LabelCanvas /></PrivateRoute>}
          />
          <Route
            path="/review"
            element={<PrivateRoute><ReviewQueue /></PrivateRoute>}
          />
          <Route
            path="/admin"
            element={<PrivateRoute><AdminOverview /></PrivateRoute>}
          />
          <Route
            path="/admin/demo-requests"
            element={<PrivateRoute><DemoQueue /></PrivateRoute>}
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
